import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Badges, P } from "../../../AbstractElements";
import CardHeaderCommon from "../../../CommonElements/CardHeaderCommon/CardHeaderCommon";
import { useEffect, useState } from "react";
import api from "../../../Api/axios";
import { format } from "date-fns";

type Props = {
  userId: string;
};
export type ServiceRecord = {
  serviceId: string;
  serviceName: string;
  requestDate: string;
  price: string;
  deals: string | null;
  status: string;
};

export type RentalRecord = {
  rentalId: string;
  productName: string;
  rentalStartDate: string;
  rentalEndDate: string;
  price: string;
  deals: string | null;
  status: string;
};

function ServiceCard({ userId }: Props) {
  const [serviceRecord, setServiceRecord] = useState<ServiceRecord[]>();
  const [rentals, setRentals] = useState<RentalRecord[]>();
  const fetchServices = async () => {
    const res = await api.get(`api/service-requests/admin/${userId}`);
    setServiceRecord(res.data.data);
  };

  const fetchRentalServices = async () => {
    try {
      const res = await api.get(`api/rent-requests/admin/${userId}`);
      setRentals(res.data.data);
    } catch (error) {}
  };
  useEffect(() => {
    fetchServices();
    fetchRentalServices();
  }, []);

  return (
    <>
      <P>Service History</P>
      <div className="overflow-x-auto mt-2 mb-5">
        <table className="table">
          {/* Table Head */}
          <thead>
            <tr>
              <th>Service ID</th>
              <th>Service Name</th>
              <th>Request Date</th>
              <th>Price</th>
              <th>Deals</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {/* Row 1 */}
            {serviceRecord && serviceRecord.length > 0 && (
              <>
                {serviceRecord.map((s) => {
                  return (
                    <tr key={s.serviceId}>
                      <th>{s.serviceId}</th>
                      <td>{s.serviceName}</td>
                      <td>{format(new Date(s.requestDate), "yyyy/MM/dd")}</td>
                      <td>{s.price} $</td>
                      <td>{s.deals}</td>
                      <td>{s.status}</td>
                    </tr>
                  );
                })}
              </>
            )}
          </tbody>
        </table>
      </div>

      <P>Rental product history</P>
      <div className="overflow-x-scroll mt-1">
        <table className="table">
          {/* Table Head */}
          <thead>
            <tr>
              <th>Rental ID</th>
              <th>Product Name</th>
              <th>Rental Start Date</th>
              <th>Rental End Date</th>
              <th>Price</th>
              <th>Deals</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {/* Row 1 */}
            {rentals &&
              rentals.length > 0 &&
              rentals.map((r) => {
                return (
                  <tr key={r.rentalId}>
                    <th>{r.rentalId}</th>
                    <td>{r.productName}</td>
                    <td>{format(new Date(r.rentalStartDate), "yyyy/MM/dd")}</td>
                    <td>{format(new Date(r.rentalEndDate), "yyyy/MM/dd")}</td>
                    <td>{r.price} $</td>
                    <td>{r.deals}</td>
                    <td>{r.status}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ServiceCard;
